import { graphql, useMutation } from 'react-relay';

const mutation = graphql`
  mutation PortfolioRetirePropertyMutation($uuid: ID!, $portfolioPropertyMemberId: ID!) {
    portfolioRetireProperty(uuid: $uuid, portfolioPropertyMemberId: $portfolioPropertyMemberId) {
      id
      uuid
    }
  }
`;

/**
 * Hook for retiring a property from a portfolio.
 * Using `useMutation` hook as recommended by [Relay docs](https://relay.dev/docs/api-reference/use-mutation/)
 * as an improvement over calling `commitMutation` directly.
 * @returns {Function} A function to trigger the retire portfolio mutation
 */
function usePortfolioRetirePropertyMutation() {
  const [commit] = useMutation(mutation);

  const portfolioRetireProperty = (uuid, portfolioPropertyMemberId, onCompleted, onError) => {
    commit({
      variables: { uuid, portfolioPropertyMemberId },
      onCompleted,
      onError,
    });
  };

  return portfolioRetireProperty;
}

export default usePortfolioRetirePropertyMutation;
